import useFetch from '../hooks/useFetch';

const getFeriados = async (dataRequest) => {
  try {
    return await useFetch.fnPost('feriados/getFeriados', dataRequest);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const guardarFeriado = async (dataRequest) => {
  try {
    return await useFetch.fnPost('feriados/guardarFeriado', dataRequest);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const eliminarFeriado = async (dataRequest) => {
  try {
    return await useFetch.fnPost('feriados/eliminarFeriado', dataRequest);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const duplicarFeriadosAnio = async (dataRequest) => {
  try {
    return await useFetch.fnPost('feriados/duplicarFeriadosAnio', dataRequest);
  } catch (error) {
    console.error(error);
    return null;
  }
};

const FeriadosService = {
  getFeriados,
  guardarFeriado,
  eliminarFeriado,
  duplicarFeriadosAnio,
};

export default FeriadosService;
